import { useEffect } from 'react';

const myExtScript = require('../assets/scripts/instagram-embed-full');

const useInstagramLazyLoader = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    myExtScript(1);

    const instEmbeds = document.getElementsByClassName(
      'ridestore-instagram-embed-custom'
    );

    const evenListeners = [];

    for (let i = 0; i < instEmbeds.length; i += 1) {
      const embed = instEmbeds[i];

      const handleScroll = () => {
        const belowScreenOffset =
          embed.offsetTop -
          document.getElementsByTagName('html')[0].scrollTop -
          window.innerHeight;

        const aboveScreenOffset =
          embed.offsetTop - document.getElementsByTagName('html')[0].scrollTop;

        if (belowScreenOffset < -200 && aboveScreenOffset > -1000) {
          window.instgrm.Embeds.process(i + 1 + 1);
        }
      };

      evenListeners.push(handleScroll);

      document.addEventListener('scroll', handleScroll);
    }

    return () => {
      for (let i = 0; i < evenListeners.length; i += 1) {
        document.removeEventListener('scroll', evenListeners[i]);
      }
    };
  }, []);
};

export default useInstagramLazyLoader;
